export default "https://cdn-static.gokick.com/assets/c9d0de51336abe1332e753a6383b3531473fb45b/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";